import {
  useIsMobile,
  WSContainer,
  WSFlexBox,
  WSIcon,
  WSLayout,
  WSMessageBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { WingspanProductAspects } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Header } from "../../Auth/components/Header/Header";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useQueryCMSWebflowPartner } from "../../query/cms/queries";
import { useLocalStorage } from "../../shared/hooks/useLocalStorage";
import { useSetWSStore, useWSStore } from "../../store";
import { GrowthSourceNames } from "../../utils/growthAttribution";
import { OnboardingQuestion } from "../components/OnboardingQuestion/OnboardingQuestion";
import styles from "./styles.module.scss";

interface OnboardingStep3PaymentsProps {}

export const OnboardingStep3Payments: React.FC<
  OnboardingStep3PaymentsProps
> = () => {
  const [answer, setAnswer] = useLocalStorage("pre-sign-up:q3", "");
  const isMobile = useIsMobile();
  const history = useHistory();
  const location = useLocation();
  const setStore = useSetWSStore();
  const store = useWSStore();

  const partnerId =
    (store.growthAttributionDetails?.growthSource ===
      GrowthSourceNames.Partner &&
      store.growthAttributionDetails?.growthName) ||
    "";
  const qPartner = useQueryCMSWebflowPartner(partnerId, {
    enabled: !!partnerId,
    onSuccess(partner) {
      setStore({ signUpType: partner.signUpType });
      setStore({ discountCode: partner.stripeDiscountCode });
    }
  });

  const partner = qPartner.data;

  const onBack = () => {
    history.push(`/member/pre-sign-up/questionnaire/2${location.search}`);
  };

  const onSubmit = async (data: any) => {
    setAnswer(data.productAspectImportance);
    history.push(`/member/sign-up${location.search}`);
  };
  return (
    <WSLayout
      onBack={isMobile ? undefined : onBack}
      line
      headerCenter={<Header hideBorder partnerLogo={partner?.logo?.src} />}
    >
      <BrowserPageTitle title="Onboarding: Step 3 | Payments" />
      <WSMessageBox kind="Warning" noBorder centered className={styles.banner}>
        {" "}
      </WSMessageBox>
      <WSContainer verticalPadding>
        {isMobile ? (
          <WSFlexBox.CenterY mb="M" onClick={() => history.goBack()}>
            <WSIcon
              block
              name="chevron-left"
              size="XS"
              mr="XS"
              color="gray600"
            />
            <WSText.ParagraphSm color="gray500">
              <b>Back</b>
            </WSText.ParagraphSm>
          </WSFlexBox.CenterY>
        ) : null}
        <OnboardingQuestion
          name="productAspectImportance"
          question={{
            question: "What could be better?",
            options: [
              {
                label: "Invoicing",
                value: WingspanProductAspects.Invoicing,
                virtualAssistantMsg:
                  "Send professional invoices to new clients in less than 30 seconds. No joke. Make it recurring with one click and we’ll do the rest.",
                ctaBtnText: "Try Payments"
              },
              {
                label: "Getting paid faster",
                value: WingspanProductAspects.PaymentSpeed,
                virtualAssistantMsg:
                  "Copy your Personal Pay Link. Share it with your client. Get paid. It's actually that simple.",
                ctaBtnText: "Try Payments"
              },
              {
                label: "Managing clients",
                value: WingspanProductAspects.ClientManagement,
                virtualAssistantMsg:
                  'Never send another "following up" email again — Wingspan chases overdue invoices on your behalf.',
                ctaBtnText: "Try Payments"
              }
            ]
          }}
          onSubmit={onSubmit}
          defaultValues={{
            productAspectImportance: answer
          }}
        />
      </WSContainer>
    </WSLayout>
  );
};
